import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "grid" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "utc-subtitle" }, "Minh chứng", -1)
const _hoisted_4 = { class: "col-12 md:col-6" }
const _hoisted_5 = { class: "col-12 md:col-6" }
const _hoisted_6 = { class: "col-12 md:col-6" }
const _hoisted_7 = { class: "col-12 md:col-6" }
const _hoisted_8 = { class: "col-12 md:col-6" }
const _hoisted_9 = { class: "col-12 md:col-6" }
const _hoisted_10 = {
  key: 0,
  class: "col-12 md:col-6"
}
const _hoisted_11 = {
  key: 1,
  class: "col-12 md:col-6"
}
const _hoisted_12 = {
  key: 2,
  class: "col-12 md:col-6"
}
const _hoisted_13 = { class: "col-12 md:col-6" }
const _hoisted_14 = { class: "col-12 md:col-6" }
const _hoisted_15 = { class: "col-12" }

import Divider from "primevue/divider";
    import ImageUploader from "../commons/ImageUploader.vue";
    import { Attachment } from "@/models/attachment.model";
    import { computed } from "@vue/reactivity";
    
export default /*#__PURE__*/_defineComponent({
  __name: 'MinhChung',
  props: {
    anhHocBaTrangDau: {},
    anhHocBaLop10: {},
    anhHocBaLop11: {},
    anhHocBaLop12: {},
    anhChungChiIelts: {},
    anhCanCuocCongDanMatTruoc: {},
    anhCanCuocCongDanMatSau: {},
    anhDoiTuongUuTien: {},
    anhKhuVucUuTien: {},
    anhDatGiai: {},
    anhDiemNangKhieu: {},
    isPriorityArea: { type: Boolean },
    isPriorityObject: { type: Boolean },
    isIeltsMark: { type: Boolean },
    group: {}
  },
  emits: ["update:anhHocBaTrangDau", "update:anhHocBaLop10", "update:anhHocBaLop11", "update:anhHocBaLop12", "update:anhChungChiIelts", "update:anhCanCuocCongDanMatTruoc", "update:anhCanCuocCongDanMatSau", "update:anhDoiTuongUuTien", "update:anhKhuVucUuTien", "update:anhDatGiai", "update:anhDiemNangKhieu"],
  setup(__props: any, { emit }) {

const props = __props;

    
    
    const anhHocBaTrangDauModel = computed<Attachment[]>({
        get: () => props.anhHocBaTrangDau,
        set: (val) => emit('update:anhHocBaTrangDau', val)
    });
    const anhHocBaLop10Model = computed<Attachment[]>({
        get: () => props.anhHocBaLop10,
        set: (val) => emit('update:anhHocBaLop10', val)
    });
    const anhHocBaLop11Model = computed<Attachment[]>({
        get: () => props.anhHocBaLop11,
        set: (val) => emit('update:anhHocBaLop11', val)
    });
    const anhHocBaLop12Model = computed<Attachment[]>({
        get: () => props.anhHocBaLop12,
        set: (val) => emit('update:anhHocBaLop12', val)
    });
    const anhChungChiIeltsModel = computed<Attachment[]>({
        get: () => props.anhChungChiIelts,
        set: (val) => emit('update:anhChungChiIelts', val)
    });
    const anhCanCuocCongDanMatTruocModel = computed<Attachment[]>({
        get: () => props.anhCanCuocCongDanMatTruoc,
        set: (val) => emit('update:anhCanCuocCongDanMatTruoc', val)
    });
    const anhCanCuocCongDanMatSauModel = computed<Attachment[]>({
        get: () => props.anhCanCuocCongDanMatSau,
        set: (val) => emit('update:anhCanCuocCongDanMatSau', val)
    });
    const anhDoiTuongUuTienModel = computed<Attachment[]>({
        get: () => props.anhDoiTuongUuTien,
        set: (val) => emit('update:anhDoiTuongUuTien', val)
    });
    const anhKhuVucUuTienModel = computed<Attachment[]>({
        get: () => props.anhKhuVucUuTien,
        set: (val) => emit('update:anhKhuVucUuTien', val)
    });
    const anhDatGiaiModel = computed<Attachment[]>({
        get: () => props.anhDatGiai,
        set: (val) => emit('update:anhDatGiai', val)
    });
    const anhDiemNangKhieuModel = computed<Attachment[]>({
        get: () => props.anhDiemNangKhieu,
        set: (val) => emit('update:anhDiemNangKhieu', val)
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Divider), {
        align: "center",
        type: "solid"
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(ImageUploader, {
        name: "anhHocBaTrangDau",
        group: _ctx.group,
        modelValue: _unref(anhHocBaTrangDauModel),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(anhHocBaTrangDauModel) ? (anhHocBaTrangDauModel).value = $event : null)),
        label: "Ảnh trang đầu học bạ (trang có dán ảnh)"
      }, null, 8, ["group", "modelValue"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(ImageUploader, {
        name: "anhHocBaLop10",
        group: _ctx.group,
        modelValue: _unref(anhHocBaLop10Model),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(anhHocBaLop10Model) ? (anhHocBaLop10Model).value = $event : null)),
        label: "Ảnh trang kết quả các môn học lớp 10"
      }, null, 8, ["group", "modelValue"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(ImageUploader, {
        name: "anhHocBaLop11",
        group: _ctx.group,
        modelValue: _unref(anhHocBaLop11Model),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(anhHocBaLop11Model) ? (anhHocBaLop11Model).value = $event : null)),
        label: "Ảnh trang kết quả các môn học lớp 11"
      }, null, 8, ["group", "modelValue"])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(ImageUploader, {
        name: "anhHocBaLop12",
        group: _ctx.group,
        modelValue: _unref(anhHocBaLop12Model),
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(anhHocBaLop12Model) ? (anhHocBaLop12Model).value = $event : null)),
        label: "Ảnh trang kết quả các môn học lớp 12"
      }, null, 8, ["group", "modelValue"])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(ImageUploader, {
        name: "anhCanCuocCongDanMatTruoc",
        group: _ctx.group,
        modelValue: _unref(anhCanCuocCongDanMatTruocModel),
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(anhCanCuocCongDanMatTruocModel) ? (anhCanCuocCongDanMatTruocModel).value = $event : null)),
        label: "Ảnh mặt trước Căn cước Công dân"
      }, null, 8, ["group", "modelValue"])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(ImageUploader, {
        name: "anhCanCuocCongDanMatSau",
        group: _ctx.group,
        modelValue: _unref(anhCanCuocCongDanMatSauModel),
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(anhCanCuocCongDanMatSauModel) ? (anhCanCuocCongDanMatSauModel).value = $event : null)),
        label: "Ảnh mặt sau Căn cước Công dân"
      }, null, 8, ["group", "modelValue"])
    ]),
    (_ctx.isIeltsMark)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createVNode(ImageUploader, {
            name: "anhChungChiIelts",
            group: _ctx.group,
            modelValue: _unref(anhChungChiIeltsModel),
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(anhChungChiIeltsModel) ? (anhChungChiIeltsModel).value = $event : null)),
            label: "Ảnh chứng chỉ Ielts"
          }, null, 8, ["group", "modelValue"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isPriorityObject)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createVNode(ImageUploader, {
            name: "anhDoiTuongUuTien",
            group: _ctx.group,
            modelValue: _unref(anhDoiTuongUuTienModel),
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_isRef(anhDoiTuongUuTienModel) ? (anhDoiTuongUuTienModel).value = $event : null)),
            label: "Ảnh minh chứng đối tượng ưu tiên"
          }, null, 8, ["group", "modelValue"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isPriorityArea)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createVNode(ImageUploader, {
            name: "anhKhuVucUuTien",
            group: _ctx.group,
            modelValue: _unref(anhKhuVucUuTienModel),
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_isRef(anhKhuVucUuTienModel) ? (anhKhuVucUuTienModel).value = $event : null)),
            label: "Minh chứng khu vực ưu tiên KV1 (Ảnh hộ khẩu hoặc mặt trước CCCD hoặc trang đầu HB)",
            multiple: true
          }, null, 8, ["group", "modelValue"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_13, [
      _createVNode(ImageUploader, {
        name: "anhDatGiai",
        group: _ctx.group,
        modelValue: _unref(anhDatGiaiModel),
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_isRef(anhDatGiaiModel) ? (anhDatGiaiModel).value = $event : null)),
        label: "Ảnh minh chứng đoạt giải nhất, nhì, ba trong kỳ thi học sinh giỏi cấp Tỉnh/Thành phố (Nếu có)"
      }, null, 8, ["group", "modelValue"])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createVNode(ImageUploader, {
        name: "anhDiemNangKhieu",
        group: _ctx.group,
        modelValue: _unref(anhDiemNangKhieuModel),
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_isRef(anhDiemNangKhieuModel) ? (anhDiemNangKhieuModel).value = $event : null)),
        label: "Ảnh Điểm năng khiếu môn Vẽ mỹ thuật (Nếu có)"
      }, null, 8, ["group", "modelValue"])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createVNode(_unref(Divider), {
        align: "center",
        type: "solid"
      })
    ])
  ]))
}
}

})